import { WebLayout } from 'components/Layout';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'react-feather';
import { useContactData } from '../api/getContactData';

// Animation Variants
const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
};

export function ContactUs() {
  const { data: contactData, isLoading: contactDataLoading } = useContactData();

  console.log(contactData);
  return (
    <WebLayout>
      <section
        className="relative h-[60vh] flex items-center justify-center bg-center bg-cover text-white"
        style={{ backgroundImage: `url(${contactData?.data?.header?.backgroundImage})` }}
      >
        <div className="absolute inset-0 bg-black/60"></div>
        <motion.div
          className="relative z-10 text-center px-4"
          variants={fadeUp}
          initial="hidden"
          animate="visible"
        >
          <h1 className="text-3xl sm:text-7xl font-semibold mb-3  just-me-again-down-here-regular">
            {contactData?.data?.header?.title}
          </h1>
          <p className="text-sm sm:text-base max-w-xl mx-auto text-gray-200">
            {contactData?.data?.header?.caption}
          </p>
        </motion.div>
      </section>
      <section className="bg-[#FFF6F2] flex flex-col items-center justify-center py-20 px-6 sm:px-12 lg:px-24">
        {/* Contact Information */}
        <motion.div
          className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-5xl w-full"
          variants={fadeUp}
          initial="hidden"
          animate="visible"
        >
          {/* Phone */}
          <div className="flex flex-col items-center text-center bg-white p-8 shadow-md rounded-lg hover:shadow-lg transition">
            <Phone className="text-[#AC3F1E] w-8 h-8 mb-3" />
            <h3 className="font-semibold text-lg mb-1">Call Us</h3>
            <div className="flex flex-col">
              {contactData?.data?.info?.phones?.map((phone) => (
                <p className="text-gray-700 text-sm">
                  {phone?.slice(0, 4)} {phone?.slice(4)}
                </p>
              ))}
            </div>
          </div>

          {/* Email */}
          <div className="flex flex-col items-center text-center bg-white p-8 shadow-md rounded-lg hover:shadow-lg transition">
            <Mail className="text-[#AC3F1E] w-8 h-8 mb-3" />
            <h3 className="font-semibold text-lg mb-1">Email Us</h3>
            {contactData?.data?.info?.emails?.map((phone) => (
              <p className="text-gray-700 text-sm">
                {phone?.slice(0, 4)} {phone?.slice(4)}
              </p>
            ))}
          </div>

          {/* Location */}
          <div className="flex flex-col items-center text-center bg-white p-8 shadow-md rounded-lg hover:shadow-lg transition">
            <MapPin className="text-[#AC3F1E] w-8 h-8 mb-3" />
            <h3 className="font-semibold text-lg mb-1">Visit Us</h3>
            <p className="text-gray-700 text-sm">{contactData?.data?.info?.address}</p>
          </div>
        </motion.div>
      </section>
    </WebLayout>
  );
}
